export default "__VITE_ASSET__6pP0QinR__"